import React from 'react'
import { ContentFallback } from '@deseretbook/react-ui'

/**
 * Fallback component - adds an action to reset the current search params
 *
 * @param {object} items - Search results
 * @param {function} refine - Refines the current search params
 *
 * @returns {function} React component
 */
export const ResultFallback = () => (
  <ContentFallback
    title="No products could be found."
    subtitle="Try clearing filters, check spelling, or using a more general search term."
    imageProps={{
      src: 'https://deseretbook.s3.amazonaws.com/images/content_fallback/feedback.svg',
      alt: 'No Results',
      alignment: 'center',
      imageWidth: '1048px',
      imageHeight: '786px',
      maxWidth: 30,
    }}
  />
)
